// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xtOQ","footer":"styles_footer__2_-Sz"};